module.exports = __webpack_public_path__ + "img/Bodice-Back-Sleeve1-Kf-La.95c3e856.png";